import { DrawerContext, DrawerProviderContext } from 'components/no-ui/context/drawer-provider'
import { useContext } from 'react'

export const useDrawer = (): DrawerProviderContext => useContext<DrawerProviderContext>(DrawerContext)
